import React, { useEffect, useState } from 'react'
import Table from '../../components/table/Table'
import { useDispatch, useSelector } from 'react-redux'
import { PAGINATION_TYPES } from '../../utils/constants'
import getPaginationData from '../../store/actions/pagination'
import { TicketsService } from '../../services'
import { tickets_columns } from '../ticket/pages/Tickets'

export default function Tickets() {
  const dispatch = useDispatch()
  const { items, currentPage, rowsPerPage, total } = useSelector(
    ({ pagination }) => pagination[PAGINATION_TYPES.TICKETS],
  )
  const isLoading = useSelector(
    ({ loader }) => loader[PAGINATION_TYPES.TICKETS],
  )
  const [searchQuery, setSearchQuery] = useState({})

  useEffect(() => {
    dispatch(
      getPaginationData({
        key: PAGINATION_TYPES.TICKETS,
        ServiceName: TicketsService,
        page: currentPage,
        per_page: 5,
        order_by: 'desc',
        ...searchQuery,
      }),
    )
  }, [currentPage, rowsPerPage, searchQuery])

  return (
    <Table
      columns={tickets_columns}
      data={items || []}
      progressPending={isLoading}
      customStyle={{
        rows: {
          style: {
            borderTop: '0px solid #E0E0E0',
            borderBottom: '1px solid #E0E0E0 !important',
            display: 'flex !important',
            alignItems: 'center !important',
            padding: 5,
          },
        },
      }}
      className='mb-5 mt-3 border-radius-10 black-shadow-15'
      style={{ border: '1px solid #9ED0F2' }}
    />
  )
}
